import React from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { useTranslation, Trans } from 'react-i18next';
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import { Controller, useForm } from "react-hook-form";
import apiHelper from "../../../utils/apiHelper";
import LinearProgress from '@material-ui/core/LinearProgress';

import {
  makeStyles,
  Box,
  Button,
  Typography,
} from "@material-ui/core";

const Overlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
  top: 0;
  left: 0;
`;

const useStylesAll = makeStyles(theme => ({
  forgetBox: {
    width: "80%",
    maxWidth: "655px",
    backgroundColor: "#FFFFFF",
    margin: "30px auto",
    color: "#000000",
    padding: "20px 20px 40px",
    [theme.breakpoints.up("md")]: {
      margin: "20vh auto",
      width: "75%",
      padding: "30px",
      padding: "30px 30px 50px",
    },
  },
  highlight: {
    color: "#962013",
    textDecoration: "none",
    '&:hover': {
      cursor: "pointer"
    }
  },
  email: {
    color: "#962013",
    fontWeight: "900"
  },
  btn: {
    marginTop: "10px",
  },
}));

function ForgetPassword(props) {
  const { setIsForget } = props;
  const classes = useStylesAll();
  const { t, i18n } = useTranslation("forgetpopup");
  const [step, setStep] = React.useState("forget");
  const [contactNumber, setContactNumber] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [seconds, setSeconds] = React.useState(0);
  const [timer, setTimer] = React.useState("(60)");
  const history = useHistory();
  const [loading, setLoading] = React.useState(false);
  const {
    control,
    setError,
    clearErrors
  } = useForm({
  });

  function toHome() {
    history.push("/" + i18n.language + "/");
  }

  const toSubmit = (event) => {
    event.preventDefault();
    var success = false;
    if (contactNumber == "") {
      setError("contactNumber", {
        type: "manual",
        message: "forget.mandatoryerror",
      });
    } else {
      sendEmail();
    }
  }

  const sendEmail = () => {
    setLoading(true);
    setSeconds(60);
    var json = {
      contactNumber: contactNumber,
    };
    apiHelper
      .reset(json)
      .then(function (response) {
        console.log(response);
        setEmail(response.data.email);
        setStep("retrieve");
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setStep("tryagain");
        setLoading(false);
      });
  }

  const toResendEmail = () => {
    if (timer == "") {
      setTimer("(60)");
      sendEmail();
    }
  }

  const toCancel = () => {
    if (step == "forget") {
      setIsForget(false);
    } else {
      history.push("/" + i18n.language + "/register");
    }
  }

  React.useEffect(() => {
    if (step == "retrieve") {
      if (seconds > 0) {
        setTimeout(() => { setSeconds(seconds - 1); setTimer("(" + (seconds - 1) + ")") }, 1000);
      } else {
        setTimer("");
      }
    }
  });

  return (
    <Overlay>
      <Box className={classes.forgetBox}>
        {(step == "forget" || step == "tryagain") &&
          <>
            <Typography variant="h1">
              {t(`${step}.title`)}
            </Typography>
            <Typography variant="h2">
              {t(`${step}.subtitle`)}
            </Typography>

            <form>
              <Box style={{ margin: "20px auto 30px" }}>
                <Controller
                  name="contactNumber"
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <InputLabel htmlFor="contactNumber" variant="outlined">
                        {t("forget.contactNumber")}
                      </InputLabel>
                      <TextField
                        id="contactNumber"
                        variant="outlined"
                        margin="dense"
                        className={classes.textInput}
                        // placeholder={t("contactNumber.placeholder")}
                        fullWidth
                        {...field}
                        error={!!error}
                        helperText={error ? t(error.message) : ""}
                        value={contactNumber}
                        onChange={(event) => { setContactNumber(event.target.value) }}
                      />
                    </>
                  )}
                />
              </Box>

              <Button
                type="submit"
                className={classes.btn}
                variant="contained"
                onClick={toSubmit}
                disabled={loading}
                fullWidth
              >
                {t(`${step}.btn`)}
              </Button>
              {loading && <LinearProgress />}

              <Typography variant="body1" align="center">
                <a className={classes.highlight} onClick={toCancel}>
                  {t(`${step}.link`)}
                </a>
              </Typography>
            </form>
          </>
        }
        {step == "retrieve" &&
          <>
            <Typography variant="h1">
              {t("retrieve.title")}
            </Typography>
            <Typography variant="h2">
              {t("retrieve.subtitle")}
            </Typography>
            <Typography variant="body1" className={classes.email}>
              {email}
            </Typography>
            <Typography variant="h2">
              {t("retrieve.checkspam")}
            </Typography>
            <Button
              type="submit"
              className={classes.btn}
              variant="contained"
              onClick={toHome}
              fullWidth
            >
              {t("retrieve.backhome")}
            </Button>
            <Typography variant="body1" align="center">
              <a className={classes.highlight} onClick={toResendEmail}>
                <Trans t={t} i18nKey="retrieve.resendemail">
                  {{ timer }}
                </Trans>
              </a>
            </Typography>

          </>
        }
      </Box>
    </Overlay>
  );
}

export default ForgetPassword;
